export default __webpack_public_path__ + "static/media/markerBold.dfe97fcd.svg";